import { Injectable, StaticProvider, TemplateRef, Type } from '@angular/core';

/**
 * Config for `SettingsSidePanelService.show()`. Deliberately separate from the legacy
 * `PanelOptionsClass` (used by `cs-side-panel-v2`/`cs-full-panel-v2`/`medium-screen-panel`) —
 * this panel has no backdrop and no built-in footer/button-bar, so most of that class's
 * fields don't apply here. Kept as its own `@Injectable` class (not just an interface) so it
 * can be supplied as a DI value token the same way `PanelOptionsClass` is for the older panels.
 */
@Injectable({
  providedIn: 'root',
})
export class SettingsSidePanelOptions<T = Record<string, unknown>> {
  id?: number | string;
  /** Panel header title. Pass an already-translated string. */
  title?: string;
  /** Width variant. Defaults to the standard settings-panel width. */
  size?: 'standard' | 'sm' | 'lg' | string;
  animated?: boolean;
  showCloseButton?: boolean;
  /** Selector/id of the element to attach the panel to. Defaults to `'body'`. */
  appendTo?: string;
  providers?: StaticProvider[];
  initialState?: Partial<T>;
  content?: string | TemplateRef<unknown> | Type<T>;
  onClose?: () => void;
}

export const SettingsSidePanelDefaults: SettingsSidePanelOptions = {
  animated: true,
  showCloseButton: true,
  appendTo: 'body',
  size: 'standard',
};
